import React from "react";
import CompositionContent from "./composition-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {formatArrayString, formatBoolean, formatSectors, intendedFunctionValue, translatedLabel, ignoredLabels, outputOrder} from "../utils/garrison-audit-utils.js";

const UpdateContent = ({element, animals}) => {
    const updateData = JSON.parse(element?.diffjson ?? "{}");
    const valueCellClassName = "whitespace-normal break-all";

    const orderedEntries = Object.entries(updateData ?? {}).sort(([a], [b]) => {
        const posA = outputOrder.indexOf(a);
        const posB = outputOrder.indexOf(b);

        if (posA === -1 && posB === -1) return 0;
        if (posA === -1) return 1;
        if (posB === -1) return -1;

        return posA - posB;
    });

    return (
        <tr className="update-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full table-fixed">

                    <thead>
                        <tr className="text-left">
                            <th style={{width: "30%"}}>Campo</th>
                            <th style={{width: "35%"}}>Novo</th>
                            <th style={{width: "35%"}}>Antigo</th>
                        </tr>
                    </thead>

                    <tbody>
                        { orderedEntries.map(([key, value], index) => {

                            if (key === "garrison_composition") {
                                return (
                                    <CompositionContent key={index} composition={value} animals={animals} isUpdate/>
                                );
                            }

                            if (key === "garrison_sectors" || key === "sectors") {
                                return (
                                    <tr key={index} className="break-all! text-left">
                                        <td>Setor</td>
                                        <td className={valueCellClassName}>{formatSectors(value?.new)}</td>
                                        <td className={valueCellClassName}>{formatSectors(value?.old)}</td>
                                    </tr>
                                );
                            }

                            if (key === "garrison_intendedfunction") {
                                return (
                                    <tr key={index} className="break-all! text-left">
                                        <td>Função destinada</td>
                                        <td className={valueCellClassName}>{intendedFunctionValue(value?.new)}</td>
                                        <td className={valueCellClassName}>{intendedFunctionValue(value?.old)}</td>
                                    </tr>
                                );
                            }

                            if (ignoredLabels.includes(key)) return null;
                            if (!translatedLabel[key]) return null;

                            const newValue = formatBoolean(formatArrayString(value?.new));
                            const oldValue = formatBoolean(formatArrayString(value?.old));

                            let label = translatedLabel[key];

                            if (key?.trim() === "attendance_lastuser") {
                                label = "Usuário que realizou alteração";
                            }

                            if (!label) return null;

                            return (
                                <tr key={index} className="break-all! text-left">
                                    <td>{label}</td>
                                    <td className={valueCellClassName}>{ReportUtils.formatObjectString(newValue)}</td>
                                    <td className={valueCellClassName}>{ReportUtils.formatObjectString(oldValue)}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default UpdateContent;